export default "__VITE_ASSET__7VGhKdUm__"